import { useEffect, useState } from "react";

import { getRemoteConfig } from "/util/countly";
import { InfoBanner, InfoBanners } from "/util/countly/types";

const useInfoBanners = (key: keyof InfoBanners) => {
  const [infoBanner, setInfoBanner] = useState<InfoBanner | null>(null);

  useEffect(() => {
    const remoteConfig = getRemoteConfig();
    const banners: InfoBanners | undefined = remoteConfig?.info_banners;

    if (!banners) return;

    const infoBanner = banners[key];

    if (infoBanner) {
      setInfoBanner(infoBanner);
    }
  }, [key]);

  return {
    enabled: infoBanner?.enabled,
    showIcon: infoBanner?.show_icon,
    messageText: infoBanner?.message_text,
    linkText: infoBanner?.link_text,
    link: infoBanner?.link,
    variant: infoBanner?.variant,
  };
};

export default useInfoBanners;
